import * as React from 'react';

var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "truck_svg__icon truck_svg__icon--truck"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 6a2.25 2.25 0 0 1 2.25-2.25h12A2.25 2.25 0 0 1 24 6v7.5a.75.75 0 0 1-1.5 0V6a.75.75 0 0 0-.75-.75h-12A.75.75 0 0 0 9 6v6a.75.75 0 0 1-1.5 0V6Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 10.5c0-2.9 2.35-5.25 5.25-5.25h3A.75.75 0 0 1 9 6v6a.75.75 0 0 1-1.5 0V6.75H5.25A3.75 3.75 0 0 0 1.5 10.5v6c0 .414.336.75.75.75H3a.75.75 0 0 1 0 1.5h-.75A2.25 2.25 0 0 1 0 16.5v-6Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.25 5.25A.75.75 0 0 1 6 6v4.5a2.25 2.25 0 0 1-2.25 2.25h-3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 0 .75-.75V6a.75.75 0 0 1 .75-.75ZM4.5 17.25a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM16.5 17.25a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM11.25 18a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  })));
};

export { SvgTruck as default };
//# sourceMappingURL=truck.svg.js.map
